/// <reference path="../../app.definition.ts" />

import _ from "lodash";
import { FormUser } from "./formUser";
import { Serializable } from "./Serializable";
import { User } from "./user";
import { FormSection } from "./formSection";
import {Subject} from "@common/model/subject";

export enum WorkflowActions {
    EDIT_AFTER_SUBMIT = 1,
    PENDING_MIGRATION = 2,
    BEGIN_DETERMINATION = 4,
    ASSIGN_SERVICE = 8
}

export class Form implements Serializable<Form> {
    id: number;
    title: string;
    description: string;
    signatureRequired: number;
    callerRole: string;

    subjectId: number;

    assignmentId: number;

    updatedAt: number;
    status: string;

    assignorId: number;
    assignor: User;

    userList: User[];
    assignees: FormUser[];
    formUsers: FormUser[];
    nonAssignors: FormUser[];
    dateSubmitted: number;
    submittedBy: number;
    submittedByFirstName: string;
    submittedByLastName: string;
    dateDue: number;
    createdAt: number;
    sections: FormSection[];
    password: string;
    workflowAction: number;
    submittedByUser?: FormUser;
    formSignature: any;
    logo: string;
    orgId: number;
    services: any;
    roles: any;
    additionalParams: any;
    userPerm;
    subject : Subject;
    showMe: boolean;
    applicableSubjectTypeValue: number;

    constructor(input?: any) {
        !!input && this.deserialize(input);
    }

    public _getFormAssignees() {
        if (!!this.formUsers) {
            this.assignees = _.uniqBy(this.formUsers.filter(fu => fu.role == "ASSIGNEE" || fu.parentRole == "ASSIGNEE" || (!fu.parentRole && !["VIEWER", "ASSIGNOR"].includes(fu.role))), 'userId');
        }
    }

    public _getFormAssignor() {
        if (!!this.formUsers) {
            let usr = this.formUsers.find(fu => fu.role == "ASSIGNOR");
            !!usr && (this.assignor = new User().deserialize(usr.user));
        }
    }

    public _getFormNonAssignors() {
        if (!!this.formUsers) {
            this.nonAssignors = this.formUsers.filter(fu => fu.role != "ASSIGNOR");
        }
    }

    deserialize(input: any) {
        !!input.id && (this.id = input.id);
        !!input.title && (this.title = input.title);
        !!input.description && (this.description = input.description);
        !!input.dateSubmitted && (this.dateSubmitted = input.dateSubmitted);
        !!input.submittedBy && (this.submittedBy = input.submittedBy);
        !!input.submittedByFirstName && (this.submittedByFirstName = input.submittedByFirstName);
        !!input.submittedByLastName && (this.submittedByLastName = input.submittedByLastName);
        !!input.submittedByUser && (this.submittedByUser = input.submittedByUser);
        !!input.dateDue && (this.dateDue = input.dateDue);
        !!input.createdAt && (this.createdAt = input.createdAt);
        !!input.subjectId && (this.subjectId = input.subjectId);
        !!input.password && (this.password = input.password);
        !!input.assignmentId && (this.assignmentId = input.assignmentId);
        !!input.assignorId && (this.assignorId = input.assignorId);
        !!input.callerRole && (this.callerRole = input.callerRole);
        //For forms with roles, we get formUser with role=COACH and parentRole=ASSIGNEE. This block
        // will add one more user object with role=ASSIGNEE
        if (input.formUsers) {
            this.formUsers = [];
            (input.formUsers || []).forEach(fu => {
                let nfu = new FormUser(fu);
                this.formUsers.push(nfu);
                if (nfu.parentRole) {
                    let cfu = new FormUser(fu);
                    cfu.role = cfu.parentRole;
                    this.formUsers.push(cfu);
                }
            });
        }
        !!this.formUsers && (this.userList = this.formUsers.filter(fu => !!fu.user).map(fu => (fu.user.permissionType = fu.role) && fu.user));
        !!input.status && (this.status = input.status);
        !!input.signatureRequired && (this.signatureRequired = input.signatureRequired);
        !!input.formSignature && (this.formSignature = input.formSignature);
        !!input.logo && (this.logo = input.logo);
        !!input.roles && (this.roles = input.roles);
        !!input.additionalParams && (this.additionalParams = input.additionalParams);
        this.workflowAction = input.workflowAction;
        this.orgId = input.orgId;
        this.services = input.services;

        if (!!input.sections) {
            this.sections = [];
            for (let sectionDef of input.sections) {
                this.sections.push(new FormSection(sectionDef));
            }
        }
        this._getFormAssignees();
        this._getFormNonAssignors();
        this._getFormAssignor();
        return this;
    }

    getUserRole = (userId: number): string => {
        if (!this.formUsers || !this.formUsers.length) {
            return null;
        }

        let formUser: FormUser = this.formUsers.find(fu => fu.userId == userId);
        if (!!formUser) {
            return formUser.getRole();
        }

        return null;
    }

    userCanShare = (userId: number): boolean => {
        //console.log("User",userId, this.callerRole == 'ASSIGNOR' || this.callerRole == 'ASSIGNEE' ? "can" : "cannot","share assignment",this.assignmentId)
        let formUser: FormUser = this.formUsers.find(fu => fu.userId == userId);

        return !!formUser && !formUser.user.isFormerTeamMember && (this.callerRole == 'ASSIGNOR' || this.callerRole == 'ASSIGNEE');
    }
}
